import { ChangeEvent } from "react";
import CheckBox from "@mui/material/Checkbox";
import { CartProduct } from "@/interfaces";
import CartProductItem from "../CartProductItem";
import Counter from "../Counter";
import { colors } from "@/theme";
import * as S from "./styles";

export type CartItemToShipCheckboxProps = {
  item?: CartProduct;
  defaultProductImageUrl?: string;
  onCheckboxChange?: (id: number, value: boolean) => void;
  onShippingQuantityChange?: (id: number, value: number) => void;
};

const CartItemToShipCheckbox: React.FC<CartItemToShipCheckboxProps> = ({
  item = undefined,
  defaultProductImageUrl = undefined,
  onCheckboxChange = undefined,
  onShippingQuantityChange = undefined,
}) => {
  if (!item) {
    return null;
  }

  return (
    <S.CartItemToShipCheckboxContainer>
      <S.CartItemToShipCheckboxCheckbox>
        <CheckBox
          checked={item.selectedToShip}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            onCheckboxChange?.(item.productId, e.target.checked);
          }}
          sx={{
            color: colors.black,
            "&.Mui-checked": {
              color: colors.ozone,
            },
          }}
        />
      </S.CartItemToShipCheckboxCheckbox>
      <S.CartItemToShipCheckboxProduct>
        <CartProductItem
          item={item}
          badge={false}
          defaultProductImageUrl={defaultProductImageUrl}
        />
      </S.CartItemToShipCheckboxProduct>
      <S.CartItemToShipCheckboxOrderQuantity>
        {item.quantity}
      </S.CartItemToShipCheckboxOrderQuantity>
      <S.CartItemToShipCheckboxShippingQuantity>
        <Counter
          value={item.shippingQuantity}
          onChange={(value: number) => {
            onShippingQuantityChange?.(item.productId, value);
          }}
        />
      </S.CartItemToShipCheckboxShippingQuantity>
    </S.CartItemToShipCheckboxContainer>
  );
};

export default CartItemToShipCheckbox;
